
// Enables or disables every item in the selector
// TODO: use $.enableAll in all places and remove this from z.util
export function enableAll(selector, enabled, disabledAttr?) {
    selector = $(selector).not(".field-visibility-disabled").not(".right-locked");

    $.each($(selector), function (i, elem) {
        var element = $(elem);
        var found = false;
        var data = element.data();
        var dataNames = Object.keys(data);

        if (element.hasClass("field-visibility-disabled") || element.parents("fieldset.field-visibility-disabled").length > 0) {
            return;
        }

        $.each(dataNames, function (j, name) {
            if (name.substring(0, 5) == "kendo") {
                var kendo = element.data(name);
                if (kendo && kendo.enable) {
                    kendo.enable(enabled);
                    found = true;
                    return false;
                }
            }
            return true;
        });

        // I am hoping this does not break anything but
        // we cannot disable things if we wish to put a tool tip
        // on them
        var isCheckBox = element.attr("type") == "checkbox";
        var isNotKendoInput = !element.hasClass("k-input") && (isCheckBox || element.attr("type") == "text" || element.is("textarea"));
        var isAutocomplete = element.attr("data-role") == "autocomplete";

        if (isCheckBox) {
            if (enabled) {
                element.siblings().removeClass("disabled");
                if (isNotKendoInput || disabledAttr) {
                    element.siblings().removeAttr("disabled");
                }
            } else {
                element.siblings().addClass("disabled");
                if (isNotKendoInput || disabledAttr) {
                    element.siblings().removeAttr("disabled");
                }
            }
        }

        if (isAutocomplete) {
            var searchPopup = $(selector).parents(".pane-field").find(".js-icon-type");
            if (enabled) {
                searchPopup.removeClass("disabled");
                if (isNotKendoInput || disabledAttr) {
                    searchPopup.removeAttr("disabled");
                }
            } else {
                searchPopup.addClass("disabled");
                if (isNotKendoInput || disabledAttr) {
                    searchPopup.removeAttr("disabled");
                }
            }
        }

        if (!found) {
            if (enabled) {
                element.removeClass("disabled");
                if (isNotKendoInput || disabledAttr) {
                    element.removeAttr("disabled");
                }
            } else {
                element.addClass("disabled");
                if (isNotKendoInput || disabledAttr) {
                    element.attr("disabled", "disabled");
                }
            }
        }
    });
}
